import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AssociationController } from 'src/features/common/association/association.controller';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AssociationApi } from 'src/features/common/association/association-api';

@Injectable()
export class PhysicalLocationOperatorChoiceApi implements AssociationApi {
  private readonly endpoint: string = 'physical/location/';
  private readonly suffix: string = '/oper-choice';

  static createAssociationApi(
    apiHelper: ApiHelper,
    associationController: AssociationController,
    injector: Injector,
  ): AssociationApi {
    return new PhysicalLocationOperatorChoiceApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (pointCd: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + pointCd + this.suffix);
  }

  public save = (parties: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + parties[0].pointCd + this.suffix, { body: parties });
  }
}
